import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import SelectAsync from 'react-select/async';

export default class TaskDo extends Base {
    constructor(props) {
        super(props);
        this.state = {
            record: props.Record,
            readOnly: props.ReadOnly,
            caller: props.Caller,
            loading: true,
            note: '',
            workingTime: 0,
            requirements: [],
            logs: [],
            steps: [],
            persons: [],
            nextPersonId: this.getDefaultGuid(),
            nextStepNumber: 0,
            attachment: '',
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    setAttachment(_attachment) {
        var ext = _attachment.type;
        if (ext == "image/webp" || ext == "image/gif" || ext == "image/png" ||
            ext == "image/jpeg" || ext == "image/jpg" || ext == "application/pdf"
            || ext == "application/vnd.ms-word" || ext == "application/vnd.openxmlformats-officedocument.wordprocessingml.document" || ext == "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            || ext == "application/vnd.ms-excel" || ext == "application/x-zip-compressed") {
            this.getBase64(_attachment).then(attachment => {
                this.state.attachment = attachment;
            });
        }
        else {
            this.showErorrMessage("فرمت فایل انتخاب شده نامعتبر است");
        }

    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.addKeyDown();
        var p1 = new Promise((resolve, reject) => {
            this.httpPost("/api/v1/solution/task/step/list", {
                filters: {
                    taskId: this.state.record.solutionTaskId
                }
            })
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === 1) {
                        this.state.logs = data.records;
                    }
                    resolve(true);
                });
        });

        var p2 = new Promise((resolve, reject) => {
            if (this.state.record.hasRequirementPricing) {
                this.httpPost("api/v1/solution/requirement/list", {
                    filters: { solutionId: this.state.record.solutionId }
                })
                    .then(data => {
                        if (data.status === -1) window.location.href = "/login";
                        if (data.status === 1) {
                            data.records.forEach(record => {
                                this.state.requirements.push({
                                    id: record.id,
                                    itemName: record.itemName,
                                    price: 0
                                });
                            });
                        }
                        resolve(true);
                    });
            }
            else {
                resolve(true);
            }
        });
        var p3 = new Promise((resolve, reject) => {
            this.httpPost("/api/v1/solution/workflow/step/list", {
                filters: {
                    solutionId: this.getDefaultGuid(),
                    workFlowId: this.state.record.solutionWorkFlowId
                }
            })
                .then(data => {
                    if (data.status === -1) window.location.href = "/login";
                    if (data.status === 1) {
                        this.state.steps = data.records;
                    }
                    resolve(true);
                });
        });
        Promise.all([p1, p2,p3])
            .then(e => {
                this.setState({
                    loading: false
                });
            });
    }
    save(e,isReject=false) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.workingTime)) this.state.workingTime = 0;
        this.state.workingTime = parseInt(this.state.workingTime);

        this.httpPost("api/v1/solution/task/do", {
            solutionTaskStepId: this.state.record.solutionTaskStepId,
            solutionTaskId: this.state.record.solutionTaskId,
            solutionWorkFlowStepId: this.state.record.solutionWorkFlowStepId,
            note: this.state.note,
            workingTime: this.state.workingTime,
            requirements: this.state.requirements,
            isReject,
            nextPersonId: this.state.nextPersonId,
            nextStepNumber: this.state.nextStepNumber,
            attachment: this.state.attachment,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.showSuccessMessage("اطلاعات با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setPrice(id, e) {
        if (this.isBlank(e)) e = "0";

        this.state.requirements.forEach(r => {
            if (r.id == id) r.price = parseInt(e);
        })
    }
    renderForm() {
        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "90%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            {!this.state.readOnly && <h4 className="modal-title">
                                انجام وظیفه
                            </h4>}
                            {this.state.readOnly && <h4 className="modal-title">
                                مشاهده سوابق
                            </h4>}
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name">{this.state.record.title}</label>
                                            {this.state.record.priorityId === 1 && <span className="text-success" style={{ "margin-right": "10px", "display": "inline-block" }}>اولویت عادی</span>}
                                            {this.state.record.priorityId === 2 && <span className="text-danger" style={{ "margin-right": "10px", "display": "inline-block" }}>اولویت فوری</span>}
                                            {this.state.record.priorityId === 3 && <span className="text-warning" style={{ "margin-right": "10px", "display": "inline-block" }}>اولویت کم</span>}
                                            <div style={{ "display": "block" }} dangerouslySetInnerHTML={{ __html: this.state.record.description }}></div>
                                            {!this.isBlank(this.state.record.attachmentUrl) && <small><a href={this.state.record.attachmentUrl} target="_blank">مشاهده فایل پیوست</a></small>}
                                        </div>
                                    </div>
                                </div>
                                {!this.state.readOnly && <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">شرح وظایف انجام شده</label><span className="red">*</span>
                                            <textarea defaultValue={this.state.note} onChange={e => this.state.note = e.target.value} autocomplete="off" type="text" className="form-control input-sm"></textarea>
                                        </div>
                                    </div>
                                </div>}
                                {!this.state.readOnly && <div className="row">
                                    {this.state.record.solutionWorkFlowStepCanUserAsign && <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">اختصاص مسئول در گام بعدی</label>
                                            <SelectAsync
                                                defaultValue={null}
                                                isMulti={false}
                                                placeholder="انتخاب مسئول"
                                                defaultOptions
                                                loadOptions={(inputValue, callback) => this.loadSolutionUsersOptions(inputValue, callback, this.state.record.solutionId)}
                                                onChange={e => this.state.nextPersonId = e.value}
                                            />
                                        </div>
                                    </div>}
                                    {this.state.record.solutionWorkFlowStepCanChangeStep && <div className="col-sm-3">
                                        <div className="form-group">
                                            <label for="name" className="title1">تغییر مرحله به</label>
                                            <select onChange={e => this.state.nextStepNumber = parseInt(e.target.value)} className="form-control">
                                                <option value="0">انتخاب مرحله توسط سیستم</option>
                                                {this.state.steps.map(step => <option value={step.step}>{step.title}</option>)}
                                            </select>
                                        </div>
                                    </div>}
                                    <div className="col-lg-3">
                                        <div className="form-group">
                                            <label className="form-label">فایل پیوست</label>
                                            <div className="form-control-wrap">
                                                <input type="file" onChange={(e) => { this.setAttachment(e.target.files[0]) }} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">مدت زمان انجام</label><span className="red">(دقیقه)</span>
                                            <input type="text" defaultValue={this.state.workingTime} onChange={e => this.state.workingTime = e.target.value} autocomplete="off" type="text" className="form-control input-sm" />
                                        </div>
                                    </div>
                                </div>}

                                {!this.state.readOnly && !this.isEmpty(this.state.requirements) &&
                                    <div className="row mt-2">
                                        <h4>برآوردهای مالی در این مرحله</h4>
                                        {this.state.requirements.map(record =>
                                            <div className="col-sm-12 mt-2">
                                                <div className="form-group">
                                                    <label for="name" className="title1">مبلغ برآورد شده برای {record.itemName}:</label>
                                                    <input defaultValue={record.price} onChange={e => this.setPrice(record.id, e.target.value)} autocomplete="off" type="text" className="form-control input-sm" style={{ "max-width": "120px" }} />
                                                </div>
                                            </div>)}
                                    </div>
                                }
                                {this.state.logs.map(log =>
                                    log.isDone && <div className="row g-4 mb-4">
                                        <div>
                                            <div className="col-lg-12 alert alert-pro alert-success rtl">
                                                <h6>{log.userName}</h6>
                                                <div dangerouslySetInnerHTML={{ __html: log.note.replace(/\n/g, '<br/>') }}></div>
                                                <div>
                                                    {!this.isBlank(log.attachmentUrl) && <small className="me-1"><a href={log.attachmentUrl} target="_blank">مشاهده فایل پیوست</a></small>}
                                                    <small className="me-1">مرحله <b style={{"display": "inline-block"}}>{log.workFlowStepName}</b></small>
                                                    <small className="me-1">تاریخ اختصاص <b>{log.assignDateString}</b></small>
                                                    <small className="me-1">تاریخ انجام <b>{log.dateString}</b></small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            {!this.state.readOnly && <button type="submit" onClick={e => this.save(e, false)} className="btn btn-success">
                                انجام شد
                            </button>}
                            {!this.state.readOnly && this.state.record.solutionWorkFlowStepCanReject &&
                            <button type="submit" onClick={e => this.save(e,true)} className="btn btn-danger">
                                رد شد - برگشت به مرحله قبلی
                            </button>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}